/**
 * Contenido del portal público (rutas desde `MEMBERSHIP_ROUTE` en `membershipAccessFlow`).
 */

import type { MembershipFunnelPath } from "@/lib/membershipAccessFlow";
import { MEMBERSHIP_ROUTE } from "@/lib/membershipAccessFlow";

export interface MembershipPortalStepDef {
  path: MembershipFunnelPath;
  title: string;
  body: string;
  cta: string;
  highlight?: boolean;
}

/** Orden = secuencia típica después del pago. */
export const MEMBERSHIP_PORTAL_STEPS: MembershipPortalStepDef[] = [
  {
    path: MEMBERSHIP_ROUTE.PORTAL_REGISTRO,
    title: "Acabo de pagar (cualquier plan de membresía)",
    body:
      "Después del pago, el sitio suele traerte acá para crear tu cuenta. Si cerraste la pestaña o no ves el formulario, abrí este enlace y usá el mismo correo que usaste al pagar.",
    cta: "Crear cuenta",
    highlight: true,
  },
  {
    path: MEMBERSHIP_ROUTE.COMPLETAR_REGISTRO,
    title: "Ya tengo cuenta y me falta completar el perfil",
    body:
      "Alias, Telegram y fecha de nacimiento. Son necesarios antes de que el equipo pueda revisar y aprobar tu acceso.",
    cta: "Completar perfil",
  },
  {
    path: MEMBERSHIP_ROUTE.PENDING_APPROVAL,
    title: "Ya envié el perfil y estoy esperando",
    body:
      "El equipo revisa tu cuenta y el pago, y asigna el link privado de ingreso. Esta página se actualiza sola cuando estés aprobado.",
    cta: "Ir a revisión / espera",
  },
  {
    path: MEMBERSHIP_ROUTE.MI_ACCESO,
    title: "Ya me aprobaron",
    body:
      "Ahí figura el link privado de ingreso (Telegram u otro canal) que te asignaron.",
    cta: "Ver mi acceso",
  },
  {
    path: MEMBERSHIP_ROUTE.ENTRAR,
    title: "Solo quiero iniciar sesión",
    body:
      "Si ya tenés cuenta y no estás en medio del alta de membresía.",
    cta: "Iniciar sesión",
  },
];
